import Instance from '../../../../Axios';

// New Actions for the app

const GetItemLimpeza = (id) => async (dispatch) => {
  console.log('id', id);
  await Instance()
    .get(`/backend/checklist/itens/${id}`)
    .then(({ data }) => {
      dispatch({ type: 'GET_ITEM_LIMPEZA', payload: data.yData[0] });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetItemLimpeza;
